(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('LogsViewerController', LogsViewerController);

    LogsViewerController.$inject = ['LogsViewerService'];

    function LogsViewerController (LogsViewerService) {
        var vm = this;

        vm.changeFile = changeFile;
        vm.list = LogsViewerService.list();

        function changeFile (name) {
            LogsViewerService.load(vm.listName, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.rows = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();
